var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Loading',[_c('Paper',{staticClass:"favorite-card-root p-4 pointer d-flex flex-column align-items-center"},[_c('div',{staticClass:"image-wrapper"},[_c('Avatar')],1),_c('Row'),_c('Row')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }